import styled from '@emotion/styled'

export const FormDescription = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #37474f;
`
